import { Utensils, Baby, Moon, Droplets, Toilet, Palette, Smile, StickyNote, Camera, Pill, AlertTriangle, LogIn, LogOut } from "lucide-react";
import api from "@/lib/api";

export const LOG_TYPES = {
  meal: { label: "Meal", Icon: Utensils, cls: "text-orange-700 bg-orange-50 border-orange-200" },
  bottle: { label: "Bottle", Icon: Baby, cls: "text-sky-700 bg-sky-50 border-sky-200" },
  nap: { label: "Nap", Icon: Moon, cls: "text-indigo-700 bg-indigo-50 border-indigo-200" },
  diaper: { label: "Diaper", Icon: Droplets, cls: "text-teal-700 bg-teal-50 border-teal-200" },
  potty: { label: "Potty", Icon: Toilet, cls: "text-emerald-700 bg-emerald-50 border-emerald-200" },
  activity: { label: "Activity", Icon: Palette, cls: "text-pink-700 bg-pink-50 border-pink-200" },
  mood: { label: "Mood", Icon: Smile, cls: "text-amber-700 bg-amber-50 border-amber-200" },
  note: { label: "Note", Icon: StickyNote, cls: "text-slate-700 bg-slate-50 border-slate-200" },
  photo: { label: "Photo", Icon: Camera, cls: "text-violet-700 bg-violet-50 border-violet-200" },
  medication: { label: "Medication", Icon: Pill, cls: "text-rose-700 bg-rose-50 border-rose-200" },
  incident: { label: "Incident", Icon: AlertTriangle, cls: "text-red-700 bg-red-50 border-red-200" },
};
export const EVENT_TYPES = {
  drop_off: { label: "Signed in", Icon: LogIn, cls: "text-emerald-700 bg-emerald-50 border-emerald-200" },
  tardy: { label: "Signed in (late)", Icon: LogIn, cls: "text-emerald-700 bg-emerald-50 border-emerald-200" },
  pickup: { label: "Signed out", Icon: LogOut, cls: "text-slate-700 bg-slate-100 border-slate-200" },
  early_dismissal: { label: "Signed out early", Icon: LogOut, cls: "text-slate-700 bg-slate-100 border-slate-200" },
};

/** Field schema per type → rendered by the quick-log dialog. */
export const LOG_FIELDS = {
  meal: [
    { key: "meal", label: "Meal", options: ["breakfast", "am snack", "lunch", "pm snack", "dinner"] },
    { key: "food", label: "What was served", text: true },
    { key: "amount", label: "Ate", options: ["all", "most", "some", "none"] },
  ],
  bottle: [{ key: "ounces", label: "Ounces", options: ["2", "3", "4", "5", "6", "8"] }, { key: "kind", label: "Type", options: ["formula", "breast milk", "milk", "water"] }],
  nap: [],
  diaper: [{ key: "result", label: "Result", options: ["wet", "BM", "wet + BM", "dry"] }],
  potty: [{ key: "result", label: "Result", options: ["tried", "pee", "BM", "accident"] }],
  activity: [{ key: "activity", label: "Activity", options: ["outdoor play", "circle time", "art", "music", "story time", "sensory", "learning centers"], text: true }],
  mood: [{ key: "mood", label: "Mood", options: ["happy", "playful", "calm", "tired", "fussy", "sad"] }],
  note: [],
  photo: [{ key: "caption", label: "Caption", text: true }],
  medication: [{ key: "name", label: "Medication", text: true }, { key: "dose", label: "Dose", text: true }],
  incident: [{ key: "summary", label: "What happened", text: true }, { key: "action", label: "Action taken", text: true }],
};

export const fmtTime = (iso) => (iso ? new Date(iso).toLocaleTimeString([], { hour: "numeric", minute: "2-digit" }) : "");

export function describe(item) {
  const d = item.data || {};
  switch (item.type) {
    case "meal": return [d.meal && d.meal[0].toUpperCase() + d.meal.slice(1), d.food, d.amount && `ate ${d.amount}`].filter(Boolean).join(" · ");
    case "bottle": return [d.ounces && `${d.ounces} oz`, d.kind].filter(Boolean).join(" ");
    case "nap": return item.ended_at ? `Slept ${Math.max(0, Math.round((new Date(item.ended_at) - new Date(item.occurred_at)) / 60000))} min` : "Sleeping…";
    case "diaper": case "potty": return d.result || "";
    case "activity": return d.activity || "";
    case "mood": return d.mood ? d.mood[0].toUpperCase() + d.mood.slice(1) : "";
    case "photo": return d.caption || "";
    case "medication": return [d.name, d.dose].filter(Boolean).join(" · ");
    case "incident": return [d.summary, d.action && `Action: ${d.action}`].filter(Boolean).join(" · ");
    default: return "";
  }
}

export async function uploadLogPhoto(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/daycare/log/photo", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return data.photo_id;
}

export function photoUrl(photoId, token) {
  return `${process.env.REACT_APP_BACKEND_URL}/api/daycare/log/photo/${photoId}?auth=${encodeURIComponent(token || "")}`;
}
